import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

export function ProjectorRouteFence({ children }) {
  const { auth } = useSelector(state => state.auth);
  const { pathname } = useLocation();
  if (auth?.role === 'projector_viewer' && !['/projector', '/projector/pnl-activity'].includes(pathname.replace(/\/$/, ''))) {
    return <Navigate to="/projector" replace />;
  }
  return children;
}

export function ProjectorReadAccess({ children }) {
  const { auth } = useSelector(state => state.auth);
  if (!auth) return <Navigate to="/auth/login" replace />;
  if (!['sup_admin', 'sub_admin', 'developer', 'projector_viewer'].includes(auth.role)) return <Navigate to="/" replace />;
  return children;
}
